export enum FreelanceJobTypes {
  FREELANCE = 'freelance',
  GEWERBE = 'gewerbe',
  VOLUNTERING_INCOME = 'volunteering_income'
}
